import React, { useMemo } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { decodeHtmlEntities } from 'functions/helpers';

const ServicesSelect = (props) => {
  const services = useSelector((state) => state.main.services);

  const handleInputChange = (newValue) => {
    props.setData?.(newValue?.value ?? 0);
  };

  const decodedServices = useMemo(() => {
    return services.map((service) => ({
      ...service,
      label: decodeHtmlEntities(service.label || ''),
    }));
  }, [services]);

  return (
    <div className="customSelectAuto">
      <Select
        isClearable="true"
        isSearchable="true"
        label="Поиск"
        options={decodedServices}
        onChange={handleInputChange}
        placeholder="Начните вводить название сервиса"
        noOptionsMessage={() => 'Ничего не найдено'}
      />
    </div>
  );
};
ServicesSelect.propTypes = {
  setData: PropTypes.func.isRequired,
};
export default ServicesSelect;
